export type BillingsTaxiDriverUpdateRequestNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date;
  checkoutEventId: string | null;
  plannedDate: Date;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiDriverUpdateRequestContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsTaxiDriverUpdateRequestContributionContractCorrectionBaseAmountExternalTaxi =
  {
    type: BillingsTaxiDriverUpdateRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    comment: string | null;
    distance: number;
    amount: number;
  };

export type BillingsTaxiDriverUpdateRequestContributionContractCorrectionRate =
  {
    type: BillingsTaxiDriverUpdateRequestContributionType.CONTRACT_CORRECTION_RATE;
    comment: string | null;
    rate: number;
  };

export type BillingsTaxiDriverUpdateRequestContributionBonusFavorableDistance =
  {
    type: BillingsTaxiDriverUpdateRequestContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsTaxiDriverUpdateRequestContributionBonusOther = {
  type: BillingsTaxiDriverUpdateRequestContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateRequestContributionPenaltyWrongRoute = {
  type: BillingsTaxiDriverUpdateRequestContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateRequestContributionPenaltyBeingLate = {
  type: BillingsTaxiDriverUpdateRequestContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateRequestContributionPenaltyIncompatibleCar =
  {
    type: BillingsTaxiDriverUpdateRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsTaxiDriverUpdateRequestContributionPenaltyOther = {
  type: BillingsTaxiDriverUpdateRequestContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateRequestContributionContractCorrection =
  | BillingsTaxiDriverUpdateRequestContributionContractCorrectionBaseAmountExternalTaxi
  | BillingsTaxiDriverUpdateRequestContributionContractCorrectionRate;

export type BillingsTaxiDriverUpdateRequestContributionBonus =
  | BillingsTaxiDriverUpdateRequestContributionBonusFavorableDistance
  | BillingsTaxiDriverUpdateRequestContributionBonusOther;

export type BillingsTaxiDriverUpdateRequestContributionPenalty =
  | BillingsTaxiDriverUpdateRequestContributionPenaltyWrongRoute
  | BillingsTaxiDriverUpdateRequestContributionPenaltyBeingLate
  | BillingsTaxiDriverUpdateRequestContributionPenaltyIncompatibleCar
  | BillingsTaxiDriverUpdateRequestContributionPenaltyOther;

export type BillingsTaxiDriverUpdateRequestContribution =
  | BillingsTaxiDriverUpdateRequestContributionBonus
  | BillingsTaxiDriverUpdateRequestContributionPenalty
  | BillingsTaxiDriverUpdateRequestContributionContractCorrection;

export type BillingsTaxiDriverUpdateRequestBody = {
  billingNodes: BillingsTaxiDriverUpdateRequestNode[];
  billingContributions: BillingsTaxiDriverUpdateRequestContribution[];
};

type BillingsTaxiDriverUpdateRequest = {
  billingUuid: string;
  billingNodes: BillingsTaxiDriverUpdateRequestNode[];
  billingContributions: BillingsTaxiDriverUpdateRequestContribution[];
};

export default BillingsTaxiDriverUpdateRequest;
